import React from "react";
import useDebounce from "external/react-use/useDebounce";

interface Props {
  value?: string | null | number;
  onChange: (value: string | number | boolean) => void;
  defaultValue: number | string | boolean;
}

export const useDeferInputChange = (props: Props) => {
  const [value, setValue] = React.useState<string | boolean | number>(
    typeof props.value === "undefined" || props.value === null
      ? props.defaultValue
      : props.value
  );

  const onChange = (event: { target: { value: any } }) => {
    const newValue = event.target.value;
    setValue(newValue);
  };
  const onChangeWithValue = (newValue: string | number) => {
    setValue(newValue);
  };
  const onInputChange = () => {
    React.startTransition(() => {
      if (value !== props.value) {
        props.onChange(value);
      }
    });
  };
  useDebounce(onInputChange, 300, [props.value, value]);
  React.useEffect(() => {
    if (
      typeof props.value !== "undefined" &&
      props.value !== value &&
      props.value !== null
    ) {
      setValue(props.value);
    }
  }, [props.value]);

  return {
    value,
    onChange,
    onChangeWithValue,
  };
};
